import type { DynamoDbBackupConfig } from '@repo/api-gw-sdk';

export const defaultDynamoDbConfiguration: DynamoDbBackupConfig = {
  isAutoscaleEnabled: false,
  maxReadCapacityPercentage: 50,
};
